import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type AsideContainerProps = {
	className?: string;
	children: any;
};

export const AsideContainer = ({
	children,
	className,
}: AsideContainerProps) => {
	return (
		<aside className={clsx(styles.asideContainer, className)}>
			{children}
		</aside>
	);
};
